/* global navigation */

/**
 * Arrow left element associated with the go back a page browser action.
 */
const goBack = {};

// Constants
const SELECTOR = '.hom-js-go-back';
const DATA = {
    action: 'goBack'
};

function canGoBack() {

    if (window.navigation) {
        return window.navigation.canGoBack;
    } else {
        return document.referrer !== '';
    }
};

/**
 * Attach go back element event listener.
 * Attach the event listener once to avoid multiple go backs
 */
goBack.addEventListener = function () {
    $('body').one('click', SELECTOR, function (e) {
        e.preventDefault();
        if (window.ReactNativeWebView && !canGoBack()) {
            // Go back a screen in the React Native app
            try {
                window.ReactNativeWebView.postMessage(JSON.stringify(DATA));
            } catch (error) {
                console.error(error);
            }
        } else {
            // Go back a page
            history.back();
        }
    });
};

module.exports = goBack;
